import { combineReducers } from '@reduxjs/toolkit'
import { sberGeoUnitSlice } from './sberGeoUnit'
import { citySlice } from './city'
import { ordersSlice } from './orders'
import { outOfficeSlice } from './outOfficeManager'
import { productsSlice } from './products'
import { reserveAccountSlice } from './reserveAccount'
import { statusesSlice } from './statuses'

export * from './city'
export * from './orders'
export * from './outOfficeManager'
export * from './products'
export * from './reserveAccount'
export * from './statuses'
export * from './sberGeoUnit'

export const ordersDesignReducers = combineReducers({
	[citySlice.name]: citySlice.reducer,
	[ordersSlice.name]: ordersSlice.reducer,
	[outOfficeSlice.name]: outOfficeSlice.reducer,
	[productsSlice.name]: productsSlice.reducer,
	[reserveAccountSlice.name]: reserveAccountSlice.reducer,
	[statusesSlice.name]: statusesSlice.reducer,
	[sberGeoUnitSlice.name]: sberGeoUnitSlice.reducer,
})
